/* global window */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { isEmpty, size } from 'underscore';
import GridView from '../../../../../components/elements/GridView/index';
import CustomEmpty from '../../../../../components/CustomEmpty';
import * as eventsActions from '../../../../../core/events/eventsActions';

class ReportTab extends PureComponent {
    onPageChange = (page, pageSize) => {
        const { onPageChange } = this.props;
        onPageChange(page, pageSize);
    };

    onTableChange = (pagination, filters, sorter, extra) => {
        const { onTableChange } = this.props;
        onTableChange(pagination, filters, sorter, extra);
    };

    render() {
        const {
            carbonReport,
            isFetching,
        } = this.props;

        const listReports = carbonReport.map((report) => (
            {
                ...report,
                ...(Array.isArray(report.name) && report.name[0] && report.name[0] !== ' ' && {
                    name: (
                        <Link to={`/assets/view/${report.name[0]}`} className="btn btn-empty">
                            {report.name[1]}
                        </Link>
                    ),
                }),
            }
        ));
        const exportableColumns = listReports && listReports[0] ? (Object.keys(listReports[0]).filter((oK) => oK.toLowerCase() != 'actions')) : [];

        return (
            <>
                {(isEmpty(listReports) && !isFetching) ? (
                    <CustomEmpty type='report' />
                ) : (
                    <>
                        {size(listReports) === 1
                            ? <CustomEmpty />
                            : (
                                <>
                                    <span className='report-title'>Carbon Report</span>
                                    <br />
                                    {!isFetching && (
                                        <GridView
                                            data={listReports}
                                            onChange={this.onTableChange}
                                            showExportButton
                                            exportableColumns={exportableColumns}
                                            disablePagination
                                        />
                                    )}
                                </>
                            )}
                    </>
                )}
            </>
        );
    }
}

ReportTab.defaultProps = {
    carbonReport: [],
    onPageChange: () => null,
    onTableChange: () => null,
};

ReportTab.propTypes = {
    carbonReport: PropTypes.array,
    isFetching: PropTypes.bool.isRequired,
    onPageChange: PropTypes.func,
    onTableChange: PropTypes.func,
};

function mapStateToProps(state, ownProps) {
    return {
        ...ownProps,
        carbonReport: state.report.carbonReport,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators({
            ...eventsActions,
        }, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(ReportTab);
